import { AppointmentParticipantStatus, AppointmentStatus } from '@gopeerproject/chuck';
import { useThemeContext } from '.';
import { getAppointmentColor } from '../utils';
export const useAppointmentStatus = (status, participantStatus) => {
    const { color } = useThemeContext();
    if (status === AppointmentStatus.Requested &&
        participantStatus === AppointmentParticipantStatus.Requested)
        return {
            text: 'Confirmation required',
            color: getAppointmentColor(color, status)
        };
    if (participantStatus === AppointmentParticipantStatus.PaymentFailed) {
        return {
            text: 'Payment verification failed',
            color: color.negative.solid
        };
    }
    switch (status) {
        case AppointmentStatus.Requested: {
            return {
                text: 'Waiting for confirmation',
                color: getAppointmentColor(color, status)
            };
        }
        case AppointmentStatus.Confirmed: {
            return {
                text: 'Confirmed',
                color: getAppointmentColor(color, status)
            };
        }
        case AppointmentStatus.Declined: {
            return {
                text: 'Declined',
                color: getAppointmentColor(color, status)
            };
        }
        case AppointmentStatus.Canceled: {
            return {
                text: 'Canceled',
                color: getAppointmentColor(color, status)
            };
        }
        case AppointmentStatus.InProgress: {
            return {
                text: 'In progress',
                color: getAppointmentColor(color, status)
            };
        }
        case AppointmentStatus.Pending: {
            return {
                text: 'Pending transaction',
                color: getAppointmentColor(color, status)
            };
        }
        case AppointmentStatus.Completed: {
            return {
                text: 'Completed',
                color: getAppointmentColor(color, status)
            };
        }
        case AppointmentStatus.DidNotHappen: {
            return {
                text: 'Did not happen',
                color: getAppointmentColor(color, status)
            };
        }
        default:
            return { text: '', color: '' };
    }
};
//# sourceMappingURL=useAppointmentStatus.js.map